import { useCallback } from "react";
import { useDefinition } from "./useDefinition";
import { jsonComparer, useMessageToState } from "./useMessageToState";
import { useProduct } from "./useProduct";

export function useAttributes() {
	const definition = useDefinition();
	const product = useProduct();

	const getState = useCallback(
		() => ({
			selectedAttributeCode: definition?.selectedAttributeCode,
			attributes: product?.attributes,
		}),
		[definition, product],
	);

	const filterMessage = useCallback((message: eXpress.core.IMessage) => {
		return (
			eXpress.core.isAttributeChanged(message) || eXpress.core.areAttributesChanged(message)
		);
	}, []);

	return useMessageToState({
		name: "useAttributes",
		filterMessage,
		getState,
		comparer: jsonComparer,
	});
}
